<template>
  <CSidebarNav class="h-100 innerContainer sidebar-custom">
    <template v-for="(item, index) in nav[0]._children" v-bind:key="index">
      <template v-if="checkPermission(item.permission)">
        <CNavItem v-if="item._name == 'CSidebarNavItem'">
          <router-link :to="item.to" class="nav-link d-flex align-items-center text-decoration-none">
            <CIcon :icon="item.icon" class="nav-icon" />
            <span class="small">{{ item.name }}</span>
          </router-link>
        </CNavItem>
        <CNavTitle v-else-if="item._name == 'CSidebarNavTitle'">
          {{ item._children[0] }}
        </CNavTitle>
        <CNavGroup class="nav-dropdown" v-bind:class="{ 'c-show': dropdownController[index] }"
          v-else-if="item._name == 'CSidebarNavDropdown'">
          <template #togglerContent>
            <CIcon :icon="item.icon" class="nav-icon" />
            <span class="small">{{ item.name }}</span>
          </template>
          <CNavItem class="nav-dropdown-items">
            <template v-for="(subItem, subIndex) in item.items" :key="subIndex">
              <template v-if="subItem.permission == null || checkPermission(subItem.permission)">
                <CNavItem class="nav-item">
                  <router-link :to="subItem.to" class="nav-link d-flex align-items-center text-decoration-none">
                    <CIcon :icon="subItem.icon" class="nav-icon ms-1" />
                    <span class="small">{{ subItem.name }}</span>
                  </router-link>
                </CNavItem>
              </template>
            </template>
          </CNavItem>
        </CNavGroup>
        <li v-else-if="item._name == 'CSidebarNavDivider'" class="mt-2"></li>
      </template>
    </template>
  </CSidebarNav>
</template>
<script>
import { CSidebarNav, CNavItem, CNavTitle, CNavGroup } from '@coreui/vue';
import { cilHome, cilCreditCard, cilBank, cilCart, cilMemory, cilSpeedometer, cilClipboard, cilFingerprint, cilUser, cilSpreadsheet, cilSettings, cilSitemap, cilPeople, cilAccountLogout } from '@coreui/icons'
import nav from './_nav'
import userService from '@/services/userService'
import { CIcon } from '@coreui/icons-vue';

export default {
  name: 'MenuItems',
  components: {
    CSidebarNav,
    CNavItem,
    CNavTitle,
    CNavGroup,
    CIcon,
  },
  data() {
    return {
      minimize: false,
      nav,
      show: 'responsive',
      dropdownController: [],
      showToken: false,
      cilHome,
      cilCreditCard,
      cilBank,
      cilCart,
      cilMemory,
      cilSpeedometer,
      cilClipboard,
      cilFingerprint,
      cilUser,
      cilSpreadsheet,
      cilSettings,
      cilSitemap,
      cilPeople,
      cilAccountLogout
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      for (var i = this.nav[0]._children.length - 1; i >= 0; i--) {
        this.dropdownController[i] = false
      }
    },
    toggle(index) {
      this.dropdownController[index] = !this.dropdownController[index]
    },
    checkPermission(permission) {
      if (permission) {
        return userService.allow(permission)
      } else {
        return true
      }
    }
  }
}
</script>
<style scoped>
.outerContainer {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
}

.innerContainer {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: -17px;
  /* Increase/Decrease this value for cross-browser compatibility */
  overflow-y: scroll;
}
</style>